const pickRandomFromArray = (items) => items[Math.floor(Math.random()*items.length)];

export default pickRandomFromArray;